import { render } from "./CreateJob.vue?vue&type=template&id=022ece98"
import script from "./CreateJob.vue?vue&type=script&lang=js"
export * from "./CreateJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__